import type { TStore, TStoreListener, TStoreOptions } from './store.types.ts';

export const createStore = <TState>(
  initialState: TState,
  { onFirstSubscribe, onLastUnsubscribe }: TStoreOptions = {},
): TStore<TState> => {
  let state = initialState;

  const listeners = new Set<TStoreListener<TState>>();

  const getState = (): TState => state;

  const setState = (next: TState): void => {
    state = next;
    listeners.forEach((listener) => listener(next));
  };

  const subscribe = (listener: TStoreListener<TState>): (() => void) => {
    if (listeners.size === 0) {
      onFirstSubscribe?.();
    }

    listeners.add(listener);

    return () => {
      if (!listeners.delete(listener) || listeners.size > 0) {
        return;
      }

      onLastUnsubscribe?.();
    };
  };

  return { getState, setState, subscribe };
};
